<template lang="html">
    <div>

        <div ref="parentSidebar" id="parentdash">
            <v-btn @click="active=true;temaSidebar()" color="green" class="btn-flotante transition delay-150 duration-300 ease-in-out transform hover:scale-5 text-white rounded-md" style="position:fixed;">
              <v-icon color="white">mdi-filter</v-icon>
            </v-btn>
            <vs-sidebar position-right default-index="1" color="#34495e" class="sidebarx" spacer click-not-close v-model="active">

                <div class="header-sidebar" slot="header">
                    <h4 class=" greyTint--text">
                        Filtros
                        <v-icon color="greyTint">mdi-filter</v-icon>
                        <v-btn class="ma-2" @click="active=false" color="red" dark><v-icon dark>mdi-close-outline</v-icon></v-btn>
                    </h4>


                </div>
                <div v-if="gfactive">
                    <vs-divider position="center">Grupo</vs-divider>
                    <vs-sidebar-item index="1">

                        <multiselect v-model="gfflotilla"
                                     :multiple="valid"
                                     :disabled="!valid"
                                     :max-height="150"
                                     @input="obtenerFlotillasporCliente()"
                                     placeholder="Seleccionar Grupo"
                                     track-by="gfclave" label="gfnombre"
                                     :options="gfflotillas" :allow-empty="true">

                        </multiselect>
                    </vs-sidebar-item>
                </div>
                <vs-divider position="center">Flotilla</vs-divider>
                <vs-sidebar-item index="2">
                    <!--:close-on-select="false"-->
                    <multiselect v-model="busqueda.flotilla"
                                 :max-height="150"
                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                 multiple
                                 :close-on-select="false"
                                 track-by="flclave" label="flnomcorto" placeholder="Seleccionar Flotilla"
                                 :options="busqueda.aseguradora != '' ? flotillasTemp : flotillas" :allow-empty="true"
                                 :taggable="true" deselect-label="Remover Valor">

                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="busqueda.flotilla != ''" @mousedown.prevent.stop="busqueda.flotilla=''"></div>
                        </template>
                    </multiselect>
                    <!--<vs-row vs-justify="center">
            <vs-alert :active="activarAlert"
                      color="danger"
                      icon="new_releases"
                      style="height: 40px; top: 6px;">
                <span>Al menos un campo debe ser llenado.</span>
            </vs-alert>
        </vs-row>-->
                </vs-sidebar-item>


                <vs-divider position="left"></vs-divider>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <div class="footer-sidebar" slot="footer">
                    <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                            <v-btn class="ma-2" @click="generarTablero()" color="blue" dark>Buscar <v-icon dark right>mdi-table-search</v-icon></v-btn>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                            <v-btn class="ma-2" @click="limpiarBusqueda()" color="red" dark>Limpiar <v-icon dark right>mdi-trash-can</v-icon></v-btn>
                        </vs-col>
                    </vs-row>
                </div>
            </vs-sidebar>
        </div>
        
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
//import SidebarService from '@/services/shared/sidebar.service.js';
import dashboard from '@/services/dashboard/dashboard.service.js';

export default {
        data: () => ({
            active: false,
            uslogin: '',
            busqueda: {
                flotilla: ''
            },
            //aseguradoras: [],
            gfflotillas: [],
            gfflotilla: [],
            flotillas: [],
            flotillasTemp: [],
            //aseguradora: [],
            visuRelevancia: false,
            activarAlert: false,
            valid:false,
            gfactive: false
        }),
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {
      ...mapMutations('Operacion', ['asignarBusqueda', 'cambiarKey', 'verificandoBusqueda']),
            busquedaDefault() {
                return {
                    flotilla: '',
                }
            },
            async generarTablero() {

                this.$emit("actualizarDashboard", this.busqueda.flotilla, this.gfflotilla, this.valid);
                    //console.log(response);
                    //console.log(this.busqueda);
                //    await dashboard.guardarFiltro(this).then(response => {
                //});
                
            },
            obtenerFlotillasporCliente() {
                this.busqueda.flotilla = '';
                //let temp = [];
                //this.busqueda.aseguradora.forEach(aitem => {
                //    temp.push.apply(temp, this.flotillas.filter(item => item.clclave == aitem.clclave));
                //})
                //this.flotillasTemp = temp;
                dashboard.obtenerFlotillasporCliente(this);
                //console.log('prueba cambio de flotillas');
            },
            limpiarBusqueda() {
                this.busqueda = { ...this.busquedaDefault() };
                //console.log('cambia');
                if (this.valid) {
                    this.gfflotilla = [];
                    dashboard.obtenerFlotillasLimpiar(this);
                    //dashboard.obtenerFlotillas(this);
                }
            },
            temaSidebar() {
                dashboard.obtenergfFlotillas(this);
                dashboard.obtenerFlotillas(this);
                if (this.THEME_STATE) {
                    document.getElementsByClassName('vs-sidebar')[0].style.background = '#23232d';

                } else {
                    document.getElementsByClassName('vs-sidebar')[0].style.background = '#FFFFFF';
                }
            },
            redireccionarIconografia() {
                this.busqueda = { ...this.busquedaDefault() };
            },
        },
        mounted() {
            this.temaSidebar();
            this.verificandoBusqueda(false);
            this.asignarBusqueda(this.busqueda);
            this.cambiarKey({ tipo: 'T', key: Math.random() });
            this.active = false;

            //dashboard.obtenerAseguradoras(this);
            dashboard.obtenergfFlotillas(this);
            dashboard.obtenerFlotillas(this);
        },
}
</script>

<style scope>
    .header-sidebar {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

        .header-sidebar h4 {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

            .header-sidebar h4 > button {
                margin-left: 10px;
            }

    .footer-sidebar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

        .footer-sidebar > button {
            border: 0px solid rgba(0,0,0,0) !important;
            border-left: 1px solid rgba(0,0,0,0.07) !important;
            border-radius: 0px !important;
        }

    .vs-sidebar {
        max-width: 350px !important;
    }

        .vs-sidebar.vs-sidebar-parent {
            position: fixed !important;
        }

    .vs-sidebar--background {
        background: none !important;
    }

    /*FLOTANTE  */
    #parentdash .btn-flotante {
        text-transform: uppercase; /* Texto en mayusculas */
        border-radius: 10px; /* Borde del boton */
        background-color: #747d8c; /* Color de fondo */
        padding: 2px 6px; /* Relleno del boton */
        position: fixed;
        top: 75px;
        right: 6px;
        transition: all 300ms ease 0ms;
        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
        z-index: 99;
        opacity: 1.3;
    }

        .btn-flotante:hover {
            background-color: #2f3542; /* Color de fondo al pasar el cursor */
            box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.3);
            transform: translateY(-7px);
        }

    @media only screen and (max-width: 600px) {
        .btn-flotante {
            padding: 2px 6px;
        }
    }
</style>